var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Email_icon_grey",
    "data-name": "Email icon grey",
    transform: "translate(-0.2 -0.171)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5554",
    "data-name": "Rectangle 5554",
    width: 23,
    height: 23,
    transform: "translate(0.2 0.171)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34364",
    "data-name": "Path 34364",
    d: "M26.67,22.524a4.007,4.007,0,0,0,.478-.028v6.142a1.423,1.423,0,0,1-1.433,1.411H10.433A1.423,1.423,0,0,1,9,28.638V19.232a1.423,1.423,0,0,1,1.433-1.411H22.4a3.827,3.827,0,0,0-.029.47,4.177,4.177,0,0,0,.941,2.641l-4.226,4.162a1.451,1.451,0,0,1-2.027,0l-5.334-5.253a.484.484,0,0,0-.676,0,.466.466,0,0,0,0,.665l5.334,5.253a2.419,2.419,0,0,0,3.376,0L23.986,21.6A4.336,4.336,0,0,0,26.67,22.524Zm0-7.524a3.292,3.292,0,1,0,3.343,3.292A3.321,3.321,0,0,0,26.67,15Z",
    transform: "translate(-8.621 -11.287)",
    fill: "#414141"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailGrey);
export default __webpack_public_path__ + "static/media/emailGrey.a60dfda03b44e6d5af547a5f4935303a.svg";
export { ForwardRef as ReactComponent };